import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SpreadsheetGuidePage from "../pages/spreadsheet-guide/page";
import SpreadsheetReviewPage from "../pages/spreadsheet-review/page";
import SafetyGuidePage from "../pages/spreadsheet-safety-guide/page";
import ComparisonPage from "../pages/spreadsheet-comparison/page";
import BeginnerGuidePage from "../pages/spreadsheet-beginner-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <SpreadsheetGuidePage />,
  },
  {
    path: "/hipobuy-spreadsheet-review",
    element: <SpreadsheetReviewPage />,
  },
  {
    path: "/spreadsheet-safety-guide",
    element: <SafetyGuidePage />,
  },
  {
    path: "/hipobuy-spreadsheet-comparison",
    element: <ComparisonPage />,
  },
  {
    path: "/hipobuy-spreadsheet-beginner-guide",
    element: <BeginnerGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;